module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: ['ge-link', _vm.theme],
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-5a36aabc"}!F:/Solutions/6713ge/master/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ge-link/ge-link.vue
// module id = 352
// module chunks = 1